import { useEffect, useState } from 'react';

import { useLocation, useParams } from 'react-router-dom';

import useTheme from 'api/useTheme';
import { extractColorValue } from 'utils/colorUtils';

import { defaultGeneralTheme } from '../GeneralSettings/defaults';

import { defaultCheckoutTheme } from './defaults';

export const useGetCheckoutInitialValues = () => {
  const location = useLocation();

  const { publisherId } = useParams();

  const [initialValues, setInitialValue] = useState<any>(defaultCheckoutTheme);

  const safeInitialValues = initialValues || defaultCheckoutTheme;

  const { getGeneralTheme: generalTheme, getCheckoutTheme: checkoutTheme } =
    useTheme(publisherId);

  useEffect(() => {
    setInitialValue({
      backgroundImage: checkoutTheme.data?.backgroundImage || '',
      buttonColor: extractColorValue(checkoutTheme.data?.buttonColor) || '',
      buttonTextColor: extractColorValue(checkoutTheme.data?.buttonTextColor) || '',
      mobileBgImage: checkoutTheme.data?.mobileBgImage || '',
      primaryColor: extractColorValue(checkoutTheme.data?.primaryColor) || '',
      textColor: extractColorValue(checkoutTheme.data?.textColor) || '',
      receiptLogo: generalTheme?.data?.logo || '',
      receiptHeader: generalTheme?.data?.receiptHeader || '',
      logo:
        checkoutTheme.data?.logo ||
        generalTheme?.data?.logo ||
        defaultGeneralTheme.logo,
      publisherId: checkoutTheme.data?.publisherId || '',
      _id: checkoutTheme.data?._id || ''
    });
  }, [checkoutTheme.data, generalTheme.data, location]);

  return { initialValues: safeInitialValues };
};
